import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { languages } from '../data/mockData';

const HeroSection = () => {
  const { t, language, languageName, changeLanguage } = useLanguage();

  return (
    <section className="relative overflow-hidden pt-28 pb-10" style={{
      background: 'linear-gradient(180deg, #1a0a2e 0%, #3d1f5c 50%, #4d2a5e 100%)'
    }}>
      {/* Subtle radial overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Hero Content */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 mb-10">
          {/* Left Content */}
          <div className="flex-1 text-left">
            <h1 className="text-5xl lg:text-6xl xl:text-7xl font-bold text-white/90 mb-4 leading-tight">
              {t('name').split(' ').slice(0, 2).join(' ')}<br />{t('name').split(' ').slice(2).join(' ')}
            </h1>
            <h2 className="text-xl lg:text-2xl xl:text-3xl text-[#c4a7d7] mb-5 font-medium">
              {t('title')}
            </h2>
            <p className="text-gray-300 text-lg lg:text-xl max-w-xl leading-relaxed">
              {t('heroDesc')}
            </p>
          </div>

          {/* Right - Profile Image */}
          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative">
              {/* Gradient Border Circle */}
              <div className="w-64 h-64 lg:w-80 lg:h-80 xl:w-96 xl:h-96 rounded-full p-1.5 shadow-2xl shadow-pink-500/30" style={{
                background: 'linear-gradient(135deg, #f472b6 0%, #fb923c 30%, #fbbf24 60%, #c084fc 100%)'
              }}>
                <div className="w-full h-full rounded-full overflow-hidden" style={{
                  background: 'linear-gradient(135deg, #fecdd3 0%, #fed7aa 50%, #fef3c7 100%)'
                }}>
                  <img
                    src="https://horizons-cdn.hostinger.com/2951c9b9-7b58-49a2-bf0b-7649f0a92130/78a8bc4778a0b8fe5c8467b061d8f4cb.jpg"
                    alt="Dr. Nawwaf Alshibli"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Language Selector */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-[#1a1a2e]/60 backdrop-blur-xl rounded-2xl p-6 border border-purple-500/10">
            {/* Header */}
            <div className="flex items-center justify-center gap-3 mb-4">
              <Globe className="w-5 h-5 text-gray-400" />
              <span className="text-base text-gray-400">{t('selectLanguage')}:</span>
              <span className="text-base text-white font-medium">{languageName}</span>
            </div>

            {/* Language Grid - 3x3 */}
            <div className="grid grid-cols-3 gap-2">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code, lang.name)}
                  className={`py-3 px-4 rounded-xl transition-all duration-300 ${
                    language === lang.code
                      ? 'bg-gradient-to-br from-pink-500 to-pink-600 text-white shadow-md shadow-pink-500/20'
                      : 'bg-[#2a2a4a]/80 text-gray-300 hover:bg-[#3a3a5a]'
                  }`}
                >
                  <div className="font-semibold text-base">{lang.name}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
